export default function getCBDFilter(isNonCBDSite) {
  return function isCBDSafe(item) {
    return isNonCBDSite && item ? !item.cbd : true
  }
}
